import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Resolver } from '@stoplight/json-ref-resolver';
import { JSONSchema7 } from 'json-schema';
import { SessionItemData } from 'src/app/workflow/services/session-item-data';

@Component({
	selector: 'workflow-schema-renderer',
	templateUrl: './schema-renderer.component.html',
	styleUrls: ['./schema-renderer.component.less']
})
export class SchemaRendererComponent implements OnChanges {

	@Input() schema: JSONSchema7;

	@Input() data: SessionItemData;

	@Input() property: string[];

	@Input() required: boolean;

	resolvedSchema: JSONSchema7;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.schema && this.schema) {
			this.resolveSchema(this.schema).catch(console.error);
		}
	}

	protected async resolveSchema(schema: JSONSchema7): Promise<JSONSchema7> {
		const resolver = new Resolver();
		const result = await resolver.resolve(schema);
		this.resolvedSchema = result.result;
		return result.result;
	}

}
